<template>
    <div ref="widget"></div>
</template>

<script type="text/babel">
import _ from 'lodash';

export default {
    name: 'kendo-grid',

    props: {
        title: {
            type: String
        },
        category: {
            type: Object
        },
        columns: {
            type: Array
        },
        label: {
            type: Object
        },
        tooltip: {
            type: Boolean,
            default: false
        },
        filename: {
            type: String,
            default: 'Export.xlsx'
        },
        dataSource: {
            type: [Object, Array]
        },
        format: {
            type: String,
            default: '{0:n2}'
        },
        scrollable: {
            type: Boolean,
            default: true
        },
        autoheight: {
            type: Boolean
        },
        height: {
            type: Number,
            default: Math.floor(Math.max(document.body.scrollHeight, document.body.offsetHeight, document.documentElement.clientHeight, document.documentElement.scrollHeight, document.documentElement.offsetHeight) / 3)
        },
        editable: {
            type: String
        },
        pageable: {
            type: [Object, Boolean],
            default: () => ({
                refresh: true,
                pageSizes: true,
                buttonCount: 5
            })
        }
    },

    data () {
        const height = this.autoheight ? (33 * _.size(this.dataSource.data)) + 30 : this.height;

        const config = {
            theme: 'bootstrap',
            dataSource: {
                data: [],
                pageSize: 20
            },
            excel: {
                allPages: true,
                fileName: this.filename
            },
            scrollable: this.scrollable,
            selectable: 'multiple cell',
            allowCopy: true,
            sortable: true,
            reorderable: true,
            resizable: true,
            pageable: this.pageable,
            columns: this.columns,
            height: height,
            tooltip: this.tooltip
        };

        if (this.dataSource) {
            if (_.isArray(this.dataSource)) {
                config.dataSource.data = this.dataSource;
            } else {
                config.dataSource = this.dataSource;
            }
        }

        if (this.editable) {
            config.editable = this.editable;
        }

        return {
            config,
            widget: undefined,
            widgetTooltip: undefined,
            image: undefined,
        };
    },

    methods: {
        exportTable () {
            this.widget.saveAsExcel();
        }
    },

    mounted () {
        this.widget = new kendo.ui.Grid(this.$refs.widget, this.config);

        if (this.config.tooltip) {
          this.widgetTooltip = new kendo.ui.Tooltip(this.$refs.widget, {
            filter: "tr > td, th",
            position: "top",
            width: 120,
            content: (e) => {
              if(e.target.is("td")) {
                return e.target.text();
              }

              if(e.target.is("th")) {
                return e.target.text();
              }
            }
          });
        }
    },

    destroyed () {
        if (this.widget) {
            this.widget.destroy();
        }
    },

    watch: {
        dataSource (val) {
            let dataSource = {
                pageSize: 20
            };
            _.isArray(val) ? dataSource.data = val : dataSource = val;
            this.widget.setDataSource(new kendo.data.DataSource(dataSource));
        },

        category (newVal, oldVal) {
            if (!_.isEqual(newVal, oldVal)) {
                const categoryAxis = Object.assign({}, this.config.categoryAxis, {
                    field: newVal.field
                });
                this.widget.setOptions({ categoryAxis });
            }
        },

        columns (newVal, oldVal) {
            if (!_.isEqual(newVal, oldVal)) {
                this.widget.setOptions({ columns: newVal });
            }
        }
    }
};
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
</style>



// WEBPACK FOOTER //
// src/modules/shared/components/kendo-grid/kendo-grid.component.vue